module.exports = __webpack_public_path__ + "img/icon-one.f4916a1f.png";